var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmlUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 20.3218L18.2484 23.4999L21.4266 20.3218",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 16V23.5",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.5H10.75C9.35761 23.5 8.02226 22.9469 7.03769 21.9623C6.05312 20.9777 5.5 19.6424 5.5 18.25C5.5 16.8576 6.05312 15.5223 7.03769 14.5377C8.02226 13.5531 9.35761 13 10.75 13C11.1892 12.9998 11.6269 13.0534 12.0531 13.1594",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16C11.5 14.8116 11.7824 13.6402 12.3239 12.5824C12.8655 11.5246 13.6506 10.6105 14.6147 9.91568C15.5787 9.22082 16.6941 8.765 17.8689 8.58578C19.0437 8.40656 20.2443 8.50907 21.3717 8.88488C22.4991 9.26068 23.5211 9.89901 24.3534 10.7473C25.1857 11.5955 25.8045 12.6294 26.1589 13.7637C26.5132 14.8981 26.5929 16.1004 26.3914 17.2716C26.1899 18.4427 25.713 19.5493 25 20.5",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlUpload);
export default __webpack_public_path__ + "static/media/xmlUpload.7aaf9a35ed7204f68e74097b5a5999e7.svg";
export { ForwardRef as ReactComponent };